import { render } from "./manage-user.vue?vue&type=template&id=4a225641"
import script from "./manage-user.vue?vue&type=script&lang=js"
export * from "./manage-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__